import { GET_EMPLOYEES, ADD_EMPLOYEE, UPDATE_EMPLOYEE, UPDATE_EMPLOYEE_EXP_SALARY } from 'redux/actionTypes';

function findEmployeeIndex(state, employeeId) {
    return state.findIndex(employee => employee.id === employeeId);
};

export default function employees(state = [], action) {
    switch(action.type) {
        case GET_EMPLOYEES:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_EMPLOYEE:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_EMPLOYEE:
            const index = findEmployeeIndex(state, action.payload.id);
            return [
                ...state.slice(0, index),
                action.payload,
                ...state.slice(index + 1)
            ];
        case UPDATE_EMPLOYEE_EXP_SALARY:
            const salaryIndex = findEmployeeIndex(state, action.payload.id);
            return [
                ...state.slice(0, salaryIndex),
                {
                    ...state[salaryIndex],
                    expectedSalaries: action.payload.expectedSalaries
                },
                ...state.slice(salaryIndex + 1)
            ];
        default:
            return state;
    }
};